// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nimg[data-v-6ecede4e] {\n\tmax-width: 15%;\n}\n", ""]);
// Exports
module.exports = exports;
